module.exports = __webpack_public_path__ + "img/list_11_tc.750b4dcc.png";